<template>
  <div>
    <v-layout wrap :class="paddingClass">
      <v-flex xs12 md6>

        <v-layout py-2 wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">Nazwa: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2">{{singleClient.name}}</span>
          </v-flex>
        </v-layout>

        <v-layout py-2 v-if="singleClient.nip" wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">NIP: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2">{{singleClient.nip}}</span>
          </v-flex>
        </v-layout>

        <v-layout py-2 v-if="singleClient.created_at" wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">Data utworzenia: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2">{{singleClient.created_at}}</span>
          </v-flex>
        </v-layout>

        <v-layout py-2 v-if="singleClient.status_txt" wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">Status: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2">{{singleClient.status_txt}}</span>
          </v-flex>
        </v-layout>

        <v-layout py-2 v-if="currentSubscription" wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">Ostatnie rozliczenie: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2">{{currentSubscription.date_from}} -
              {{currentSubscription.date_to}},
              {{currentSubscription.space_available}},
              {{currentSubscription.paid_status_txt}}
              </span>
          </v-flex>
        </v-layout>

        <v-layout py-2 v-if="singleClient.pin" wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">Kod PIN: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2">{{singleClient.pin}}</span>
          </v-flex>
        </v-layout>

      </v-flex>
      <v-flex xs12 md6>

        <v-layout py-2 v-if="hasAdress" wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">Dane adresowe: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2">
              ul. {{singleClient.address_street}},<br/>
              {{addressZip}} {{singleClient.address_city}}
            </span>
          </v-flex>
        </v-layout>

        <v-layout py-2 v-if="hasContactAdress" wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">Dane kontaktowe: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2">
              ul. {{singleClient.contact_address_street}},<br/>
              {{contactAddressZip}} {{singleClient.contact_address_city}}
            </span>
          </v-flex>
        </v-layout>

        <v-layout py-2 v-if="hasPhoneNumbers" wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">Telefon: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2" v-html="hasPhoneNumbers">
            </span>
          </v-flex>
        </v-layout>

        <v-layout py-2 v-if="hasEmail" wrap>
          <v-flex xs12 sm3>
            <span class="grey--text text--darken-2 body-1">Adres e-mail: </span>
          </v-flex>
          <v-flex xs12 sm9>
            <span class="body-2" v-html="hasEmail">
            </span>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'client-info',
  props: ['singleClient'],
  computed: {
    currentSubscription() {
      return this.singleClient.current_subscription;
    },
    hasAdress() {
      const street = this.singleClient.address_street;
      const zip = this.singleClient.address_zip;
      const city = this.singleClient.address_city;
      return !!(street && zip && city);
    },
    hasContactAdress() {
      const street = this.singleClient.contact_address_street;
      const zip = this.singleClient.contact_address_zip;
      const city = this.singleClient.contact_address_city;
      return !!(street && zip && city);
    },
    hasPhoneNumbers() {
      const phone1 = this.singleClient.contact_phone_1;
      const phone2 = this.singleClient.contact_phone_2;
      const phoneNumber1 = phone1 ? `<a href="tel:${phone1}">${phone1}</a>` : '';
      const phoneNumber2 = phone2 ? `<br/><a href="tel:${phone2}">${phone2}</a>` : '';
      return (phone1 || phone2) ? `${phoneNumber1}${phoneNumber2}` : false;
    },
    hasEmail() {
      const mail = this.singleClient.contact_email;
      const mailHtml = `<a href="mailto:${mail}">${mail}</a>`;
      return mail ? mailHtml : false;
    },
    addressZip() {
      const zip = this.singleClient.address_zip;
      return `${zip.substr(0, 2)}-${zip.substr(2, 3)}`;
    },
    contactAddressZip() {
      const zip = this.singleClient.contact_address_zip;
      return `${zip.substr(0, 2)}-${zip.substr(2, 3)}`;
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-3 py-2' : 'pa-4';
    },
  },
};
</script>
